import React from 'react';
import { SVGS } from '@zonofi/zono-money-design-system';
import './invoice-header.scss';
import { useAppSelector } from '@zonofi/zono-money-helpers';
import {
  DateRangeState,
  dispatch,
  getCustomerInvite,
  updateIsSideDrawerOpen,
} from '@zonofi/zono-money-store';
import { DateRangeFilter } from '../date-range-filter/date-range-filter';

interface InvoiceHeaderProps {
  showSearch: boolean;
  setShowSearch: (val: boolean) => any;
  searchKey: string;
  setSearchKey: (val: string) => any;
  showCategory: boolean;
  appliedDateRange: DateRangeState;
  applyNewDateRange: (dateRange?: DateRangeState) => void;
  openFiltersDrawer: (filterPage: string) => void;
}

export const InvoiceHeader: React.FC<InvoiceHeaderProps> = ({
  showSearch,
  setShowSearch,
  searchKey,
  setSearchKey,
  showCategory,
  appliedDateRange,
  applyNewDateRange,
  openFiltersDrawer,
}) => {
  const searchInputRef = React.useRef<HTMLInputElement>(null);
  const inviteData = useAppSelector(getCustomerInvite);
  const openDrawer = () => {
    dispatch(updateIsSideDrawerOpen(true));
  };
  if (showSearch) {
    return (
      <div
        className={`invoice-header-search font-primary${
          !showCategory ? ' invoice-header-category-not-visible' : ''
        }`}
      >
        <div className="invoice-header-search-root">
          <img
            height={15}
            width={15}
            src={SVGS.LeftArrowBlack}
            alt="back"
            onClick={() => {
              setSearchKey('');
              setShowSearch(false);
            }}
          />
          <input
            className="invoice-header-search-input font-primary-semibold"
            value={searchKey}
            placeholder="Search with Invoice Number"
            autoFocus
            onChange={(e) => {
              setSearchKey(e?.target?.value);
            }}
            ref={searchInputRef}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                searchInputRef?.current?.blur();
              }
            }}
          />
          {searchKey?.length !== 0 && (
            <>
              <img
                src={SVGS.XCircle}
                alt="clear"
                onClick={() => {
                  setSearchKey('');
                }}
              />
              <div className="invoice-header-search-root-divider" />
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`invoice-header font-primary${
        !showCategory ? ' invoice-header-category-not-visible' : ''
      }`}
    >
      <div className="invoice-header-contents">
        <div className="invoice-header-seller">
          <div
            className="invoice-header-seller-logo-container"
            onClick={openDrawer}
          >
            {inviteData?.seller?.profileImg ? (
              <img
                src={inviteData?.seller?.profileImg}
                className="invoice-header-seller-logo-container-img"
              />
            ) : (
              <img src={SVGS.UserProfileIcon} />
            )}
          </div>
          <div className="invoice-header-seller-info">
            <span className="invoice-header-seller-info-name font-primary-semibold">
              {inviteData?.seller?.name}
            </span>
            <span className="invoice-header-seller-info-subtitle font-primary">
              Invoices
            </span>
          </div>
        </div>
        <div className="invoice-header-options">
          <img
            src={SVGS.Search}
            alt="search"
            onClick={() => setShowSearch(true)}
          />
          <img
            src={SVGS.FiltersIcon}
            alt="filters"
            onClick={() => openFiltersDrawer('filters')}
          />
          <DateRangeFilter
            dateRange={appliedDateRange}
            setDateRange={(datesRange) => {
              applyNewDateRange(datesRange);
            }}
            handleCustomRange={() => {
              openFiltersDrawer('DateRange');
            }}
          />
        </div>
      </div>
    </div>
  );
};
